import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { PayloadDetailPublicationI } from '../../../models/payloadDetailPublication';
import { HttpClient } from '@angular/common/http';
import { DocumentStoreInitI } from '../../../models/folder';

@Injectable({ providedIn: 'root' })
export class PublicationPayloadService {
    serviceUrl = '/webfront/document';
    filter: any = { attributes: {} };
    initSearchItem: any = {};
    selectedDate: any;
    goToPublicationDetailSubject: Subject<PayloadDetailPublicationI> = new Subject();

    constructor(private httpClient: HttpClient) {}

    goToPublicationDetail(payload: PayloadDetailPublicationI): void {
        this.goToPublicationDetailSubject.next(payload);
    }

    // Scoped to a single project's folders, or to the given folders directly (used for folders shared with
    // the current user whose owning project they otherwise have no access to) - exactly one of the two must
    // be given. Kept bounded rather than fetching every folder the user can access. Not cached client-side
    // for now, unlike before this was scoped down.
    prepareStore(projectId?: number, folderIds?: number[]): Observable<DocumentStoreInitI> {
        const params: Record<string, string | string[]> = {};
        if (projectId != null) {
            params.projectId = `${projectId}`;
        }
        if (folderIds?.length) {
            params.folderIds = folderIds.map(folderId => `${folderId}`);
        }
        return this.httpClient.get<DocumentStoreInitI>(`${this.serviceUrl}/store/init`, { params });
    }

    // The folders shared with the current user where they have EDIT permission - a READ-only share isn't a
    // valid target when picking a folder to save a publication into.
    prepareStoreShared(): Observable<DocumentStoreInitI> {
        return this.httpClient.get<DocumentStoreInitI>(`${this.serviceUrl}/store/init/shared`);
    }

    // The folders the current user pinned for quick access - their own pinned folders, plus shared ones they
    // pinned where they have EDIT permission.
    prepareStorePinned(): Observable<DocumentStoreInitI> {
        return this.httpClient.get<DocumentStoreInitI>(`${this.serviceUrl}/store/init/pinned`);
    }
}
